import { IELTLastMeetingData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { v4 as uuid4 } from 'uuid'

export const getNewRecord = (): IELTLastMeetingData => ({
  id: uuid4(),
  action: '',
  status: '',
  update: '',
})
